module.exports = __webpack_public_path__ + "static/media/motivation.db91ccee.svg";